import { apiSlice } from '../../api/apiSlice'

const apiClientData = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getClientData: builder.query({
      query: (body) => ({
        url: `/client/data`,
        method: 'get',
        body,
      }),
    }),
    getClientOrders: builder.query({
      query: () => '/client/orders',
    }),
    deleteZeroOrder: builder.mutation({
      query: (body) => ({
        url: '/client/orders/delete',
        method: 'DELETE',
        body,
      }),
    }),
    getOrderPermission: builder.mutation({
      query: () => ({
        url: '/client/orders/permission',
        method: 'GET',
      }),
    }),
    getClientPaymentPlan: builder.query({
      query: () => '/client/payment-plan',
    }),
    getClientPaymentHistory: builder.query({
      query: () => '/client/payment-history',
    }),
    getClientSearchHistory: builder.query({
      query: () => '/client/search-history',
    }),
    getClientOrderHistory: builder.query({
      query: () => '/client/orders/history',
    }),
    getClientOrderHistoryWithRetail: builder.query({
      query: () => ({
        url: '/client/orders/history',
        params: { useRetailCoefficient: 'true' },
      }),
    }),
    getClientOrderDoc: builder.mutation({
      query: (body) => ({
        url: '/client/orders/history/doc',
        method: 'POST',
        body,
      }),
    }),
    getClientOrderDocWithRetail: builder.mutation({
      query: (body) => ({
        url: '/client/orders/history/doc',
        method: 'POST',
        body: { ...body, useRetailCoefficient: 'true' },
      }),
    }),
    getAllClientOrderDocsWithRetail: builder.mutation({
      query: () => ({
        url: '/client/orders/history/doc',
        method: 'POST',
        body: { useRetailCoefficient: 'true', useAllDocs: 'true' },
      }),
    }),
    getAllClientOrderDocs: builder.mutation({
      query: () => ({
        url: '/client/orders/history/doc',
        method: 'POST',
        body: { useAllDocs: 'true' },
      }),
    }),
    getClientOrderDocPdf: builder.mutation({
      query: (body) => ({
        url: `/client/orders/history/doc-pdf`,
        method: 'POST',
        body,
        responseHandler: async (response) => {
          if (!response.ok) {
            return { success: false }
          }
          const blob = await response.blob()
          const downloadUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = downloadUrl
          a.download = `invoice_${body.docID}.pdf`
          document.body.appendChild(a)
          a.click()
          a.remove()
          return { success: true }
        },
      }),
    }),
    getClientOrderDocPdfWithRetail: builder.mutation({
      query: (body) => ({
        url: `/client/orders/history/doc-pdf`,
        method: 'POST',
        body: { ...body, useRetailCoefficient: 'true' },
        responseHandler: async (response) => {
          if (!response.ok) {
            return { success: false }
          }
          const blob = await response.blob()
          const downloadUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = downloadUrl
          const fileName = body.docID === null ? 'invoice.pdf' : `invoice_${body.docID}.pdf`
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          a.remove()
          return { success: true }
        },
      }),
    }),
    getClientOrderDocXlsx: builder.mutation({
      query: (body) => ({
        url: `/client/orders/history/doc-xlsx`,
        method: 'POST',
        body,
        responseHandler: async (response) => {
          if (!response.ok) {
            return { success: false }
          }
          const blob = await response.blob()
          const downloadUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = downloadUrl
          a.download = `invoice_${body.docID}.xlsx`
          document.body.appendChild(a)
          a.click()
          a.remove()
          return { success: true }
        },
      }),
    }),
    getClientOrderDocXlsxWithRetail: builder.mutation({
      query: (body) => ({
        url: `/client/orders/history/doc-xlsx`,
        method: 'POST',
        body: { ...body, useRetailCoefficient: 'true' },
        responseHandler: async (response) => {
          if (!response.ok) {
            return { success: false }
          }
          const blob = await response.blob()
          const downloadUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = downloadUrl
          const fileName = body.docID === null ? 'invoice.xlsx' : `invoice_${body.docID}.xlsx`
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          a.remove()
          return { success: true }
        },
      }),
    }),
    getClientDeliveries: builder.query({
      query: () => '/client/deliveries',
    }),
    getClientPaymentSource: builder.query({
      query: () => '/client/payment-source',
    }),
    editCustomRetailPrice: builder.mutation({
      query: (body) => ({
        url: '/client/custom-retail-coefficient',
        method: 'PUT',
        body,
      }),
    }),
    getClientCustomRetailPrice: builder.query({
      query: () => '/client/custom-retail-coefficient',
    }),
    saveClientVinSearch: builder.mutation({
      query: (body) => ({
        url: '/client/vin-search',
        method: 'POST',
        body,
      }),
    }),
    addClientSavedOrder: builder.mutation({
      query: (body) => ({
        url: '/client/saved-orders',
        method: 'POST',
        body,
      }),
    }),
    getClientSavedOrders: builder.query({
      query: () => '/client/saved-orders',
    }),
    getClientSavedOrderLastGroup: builder.query({
      query: () => '/client/saved-orders/last-group',
    }),
    getClientSavedOrderGroupNames: builder.query({
      query: () => '/client/saved-orders/group-names',
    }),
    markClientSavedOrder: builder.mutation({
      query: (body) => ({
        url: '/client/saved-orders',
        method: 'PUT',
        body,
      }),
    }),
  }),
})

export const {
  useGetClientDataQuery,
  useGetClientOrdersQuery,
  useGetClientPaymentPlanQuery,
  useGetOrderPermissionMutation,
  useGetClientPaymentHistoryQuery,
  useGetClientSearchHistoryQuery,
  useGetClientOrderHistoryQuery,
  useGetClientOrderHistoryWithRetailQuery,
  useGetClientOrderDocMutation,
  useGetClientOrderDocWithRetailMutation,
  useGetAllClientOrderDocsWithRetailMutation,
  useGetAllClientOrderDocsMutation,
  useGetClientOrderDocPdfMutation,
  useGetClientOrderDocPdfWithRetailMutation,
  useGetClientOrderDocXlsxMutation,
  useGetClientOrderDocXlsxWithRetailMutation,
  useDeleteZeroOrderMutation,
  useGetClientDeliveriesQuery,
  useGetClientPaymentSourceQuery,
  useEditCustomRetailPriceMutation,
  useGetClientCustomRetailPriceQuery,
  useSaveClientVinSearchMutation,
  useAddClientSavedOrderMutation,
  useGetClientSavedOrdersQuery,
  useGetClientSavedOrderLastGroupQuery,
  useGetClientSavedOrderGroupNamesQuery,
  useMarkClientSavedOrderMutation,
} = apiClientData
